import React from 'react';
import { ProgressSpinner } from '@everfi/reactifi';

interface FallbackProps {
  children?: React.ReactNode;
}

const Fallback: React.FC<FallbackProps> = ({ children = null }) => (
  <>
    <div>
      <header id="header"></header>
    </div>
    <nav id="sidebar" className="nav sidebar"></nav>
    <main id="main" className="p2">
      <div id="content" className="fallback-content">
        {children || <ProgressSpinner pageLoader={true} />}
      </div>
    </main>
  </>
);

export default Fallback;
